import React from 'react';
import { IoMdClose } from 'react-icons/io';

const ModalPopUp = ({ VideoName,VideoLink, ShowVideo }) => {
    return (
        <>
            <div className="modal show">
                <div className="modal_container">
                    <div className="details_close_button_wrapper">
                        <p className="modal_video_details"> { VideoName}</p>
                        <IoMdClose
                            id="close"
                            onClick={() => ShowVideo(false)}
                        />
                    </div>
                    <div className="iframe_container">
                        <iframe
                            width={560}
                            height={315}
                            src={VideoLink}
                            title="YouTube video player"
                            frameBorder={0}
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen=""
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalPopUp;
